(function () {
  const STORAGE_KEY = 'product-view-mode';

  function getProductGrid() {
    const container = document.getElementById('ProductGridContainer');
    if (!container) return null;
    return container.querySelector('#product-grid.product-grid');
  }

  function updateView(view) {
    const grid = getProductGrid();
    if (!grid) return;

    const mode = view === 'list' ? 'list' : 'grid';
    grid.classList.remove('grid-view', 'list-view');
    grid.classList.add(`${mode}-view`);

    document.querySelectorAll('.view-mode-selector .view-btn').forEach((btn) => {
      btn.classList.toggle('active', btn.dataset.view === mode);
    });
  }

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('.view-mode-selector .view-btn');
    if (!btn || !btn.dataset.view) return;

    event.preventDefault();
    event.stopPropagation();

    updateView(btn.dataset.view);
    localStorage.setItem(STORAGE_KEY, btn.dataset.view);
  });

  document.addEventListener('DOMContentLoaded', () => {
    updateView(localStorage.getItem(STORAGE_KEY) || 'grid');
  });

  document.addEventListener('productgrid:updated', () => {
    updateView(localStorage.getItem(STORAGE_KEY) || 'grid');
  });
})();
